import { render, staticRenderFns } from "./mechanismDetail.vue?vue&type=template&id=33a42b23&scoped=true"
import script from "./mechanismDetail.vue?vue&type=script&lang=js"
export * from "./mechanismDetail.vue?vue&type=script&lang=js"
import style0 from "./mechanismDetail.vue?vue&type=style&index=0&id=33a42b23&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33a42b23",
  null
  
)

export default component.exports